import {Calendar} from './Calendar';
import {useState} from 'react';
import * as React from "react";
import {TermsAndConditions} from "./TermsAndConditions";
import {ContainerDescription} from "./ContainerDescription";
import {OrderConfirm} from "./OrderConfirm";
import {CompanyFormData} from "./CompanyFormData";
import {PersonFormData} from "./PersonFormData";
import {AddressField} from "./AddressField";
import {useRef} from 'react';
import {Loader} from "./Loader";
import {RequestForm} from "./RequestForm";
import {Header} from './Header'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import {resetSelectedBoxValues} from './Utils/ResetSelectBoxValues';
import {markSelectBoxValue} from './Utils/MarkSelectBoxValue';
import {ContainerDescriptionButton} from "./ContainerDescriptionButton";
import {ScrollTopButton} from "./ScrollTopButton";
import {DaysCountForFreeParkingLabel} from "./DaysCountForFreeParkingLabel";

export const Form = () => {
    const [address, setAddress] = useState('');
    const [selectedAddress, setSelectedAddress] = useState(window.selectedAddress);
    const [trashType, setTrashType] = useState('');
    const [selectedTrashType, setSelectedTrashType] = useState(window.selectedTrashType);
    const [containerSize, setContainerSize] = useState('');
    const [selectedContainerSize, setSelectedContainerSize] = useState(window.selectedContainerSize);
    const [nameSurname, setNameSurname] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [message, setMessage] = useState('');
    const [termAndConditions, setTermsAndConditions] = useState(false);
    const [trashTypes, setTrashTypes] = useState(window.trashTypes);
    const [trashTypesWithSizesMap, setTrashTypesWithSizesMap] = useState(window.trashTypesWithSizesMap);
    const [trashTypeSizesMap, setTrashTypeSizesMap] = useState(['-']);
    const [containerSizes, setContainerSizes] = useState(window.containerSizes);
    const [translations, setTranslations] = useState(window.translations);
    const [siteSettings, setSiteSettings] = useState(window.siteSettings);
    const [maxYearToSelect, setMaxYearToSelect] = useState(window.maxYearsToSelect);
    const [withoutValues, setWithoutValues] = useState(true);
    const [withValues, setWithValues] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedPrice, setSelectedPrice] = useState('--');
    const [selectedContainer, setSelectedContainer] = useState('--');
    const [containerId, setContainerId] = useState('--');
    const [emailError, setEmailError] = useState(false);
    const [personalCodeError, setPersonalCodeError] = useState(false);
    const [responsiblePersonError, setResponsiblePersonError] = useState(false);
    const [nameSurNameError, setNameSurnameError] = useState(false);
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [termsAndConditionsError, setTermsAndConditionsError] = useState(false);
    const [trashTypeError, setTrashTypeError] = useState(false);
    const [containerSizeError, setContainerSizeError] = useState(false);
    const [addressError, setAddressError] = useState(false);
    const [selectedDateError, setSelectedDateError] = useState(false);
    const [orderConfirmed, setOrderConfirmed] = useState(false);
    const [onRequestOrder, setOnRequestOrder] = useState(false);
    const [selectedContainerSizeImage, setSelectedContainerSizeImage] = useState('images/container-not-selected-full.png');
    const [hash, setHash] = useState('');
    const [showLoader, setShowLoader] = useState('hide');
    const ref = useRef(null);
    const beforeForm = useRef(null);
    const [containersNotFound, setContainersNotFound] = useState(false);
    const [orderPersonType, setOrderPersonType] = React.useState('individual');
    const [personalCode, setPersonalCode] = useState('');
    const [responsiblePerson, setResponsiblePerson] = useState('');

    const searchAvailability = (event: any) => {
        let valid = true;

        setHash(trashType.concat(containerSize, address, trashType));
        setSelectedDateError(false);
        if (!trashType || trashType.length == 0) {
            setTrashTypeError(true);
            valid = false;
        } else {
            setTrashTypeError(false);
        }

        if (!containerSize || containerSize.length == 0) {
            setContainerSizeError(true);
            valid = false;
        } else {
            setContainerSizeError(false);
        }

        if (!address || address.length < 6) {
            setAddressError(true);
            valid = false;
        } else {
            setAddressError(false);
        }

        if (valid) {
            setWithValues(true);
            setWithoutValues(false);
            ref.current?.scrollIntoView({behavior: 'smooth'});

            if (selectedTrashType != '') {
                setSelectedTrashType('');
            }
            if (selectedContainerSize != '') {
                setSelectedContainerSize('');
            }

            if (selectedAddress != '') {
                setSelectedAddress('');
            }
        } else {
            setWithValues(false);
            setWithoutValues(true);
        }
    }

    const submitOrder = (event) => {
        event.preventDefault();
        const formDetails = {
            trashType: trashType,
            containerSize: containerSize,
            address: address,
            price: selectedPrice,
            date: selectedDate,
            containerId: selectedContainer,
            nameSurname: nameSurname,
            email: email,
            personalCode: personalCode,
            phoneNumber: phoneNumber,
            message: message,
            termsAndCondition: termAndConditions,
            orderPersonType: orderPersonType,
            responsiblePerson: responsiblePerson
        };

        let valid = true;

        if (!trashType || trashType.length == 0) {
            setTrashTypeError(true);
            valid = false;
        } else {
            setTrashTypeError(false);
        }

        if (!containerSize || containerSize.length == 0) {
            setContainerSizeError(true);
            valid = false;
        } else {
            setContainerSizeError(false);
        }

        if (!address || address.length < 6) {
            setAddressError(true);
            valid = false;
        } else {
            setAddressError(false);
        }

        const emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");

        if (!emailRegex.test(email)) {
            setEmailError(true);
            valid = false;
        } else {
            setEmailError(false);
        }

        if (!nameSurname || nameSurname.length < 6) {
            setNameSurnameError(true);
            valid = false;
        } else {
            setNameSurnameError(false);
        }

        if (orderPersonType == 'company' && (!responsiblePerson || responsiblePerson.length < 10)) {
            setResponsiblePersonError(true);
            valid = false;
        } else {
            setResponsiblePersonError(false);
        }

        if (orderPersonType == 'company' && (!personalCode || personalCode.length < 7)) {
            setPersonalCodeError(true);
            valid = false;
        } else {
            setPersonalCodeError(false);
        }

        if (!selectedDate) {
            setSelectedDateError(true);
            valid = false;
        } else {
            setSelectedDateError(false);
        }
        //
        // const phoneRegex = /^(?:\+370)([5-9]\d{7})$/;
        // if (!phoneRegex.test(phoneNumber)) {
        //     setPhoneNumberError(true);
        //     valid = false;
        // } else {
        //     setPhoneNumberError(false);
        // }

        if (!termAndConditions) {
            setTermsAndConditionsError(true);
            valid = false;
        } else {
            setTermsAndConditionsError(false);
        }

        if (valid) {
            event.target.disabled = true;
            const options = {
                method: 'POST',
                body: JSON.stringify(formDetails)
            };

            fetch(
                "/create-order", options)
                .then((res) => res.json())
                .then((daysToHighlight) => {
                    const box = document.getElementById('order-form');
                    box.style.display = 'none';
                    setOrderConfirmed(true);

                    if (selectedPrice == 'Klausti') {
                        setOnRequestOrder(true);
                    }
                });
        }
    }

    const handleContainerSizeSelection = (event) => {
        if (event.target.value == '-') {
            setContainerSize('');

        } else {
            setContainerSize(event.target.value);
        }
        const item = containerSizes.filter(containerSizeItem => containerSizeItem.id == event.target.value);
        setSelectedContainerSizeImage(item[0].photo);
    }

    const handleTrashTypeSelection = (event: any) => {
        if (event.target.value == '') {
            setTrashType('');
            setTrashTypeSizesMap(['-']);
        } else {
            setTrashType(event.target.value);
            setTrashTypeSizesMap(trashTypesWithSizesMap[event.target.value]);
        }
    }

    const handleOrderPersonTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setOrderPersonType((event.target as HTMLInputElement).value);
    };

    React.useEffect(() => {
        if (selectedTrashType != '' && selectedContainerSize != '' && trashTypesWithSizesMap != undefined) {
            setTrashType(selectedTrashType);
            setTrashTypeSizesMap(trashTypesWithSizesMap[selectedTrashType]);

            markSelectBoxValue('trashType', selectedTrashType);
        }
    }, [trashTypesWithSizesMap]);

    React.useEffect(() => {
        resetSelectedBoxValues('containerSize');
        setContainerSize('');
        setContainerId('--');
        setSelectedContainerSizeImage('images/container-not-selected-full.png')
        setWithValues(false);
        setWithoutValues(true);

        if (selectedTrashType != '' && selectedContainerSize != '' && trashTypesWithSizesMap != undefined) {
            setContainerSize(selectedContainerSize);
            markSelectBoxValue('containerSize', selectedContainerSize);

            const item = containerSizes.filter(containerSizeItem => containerSizeItem.id == selectedContainerSize);
            setSelectedContainerSizeImage(item[0].photo);
            window.history.replaceState(null, "New Page Title", "/");
        }
    }, [trashType]);


    React.useEffect(() => {
        if (trashType != '') {
            searchAvailability([]);

            window.history.pushState(null, '', window.location.href);
            window.onpopstate = function () {
                window.history.go(1);
                document.documentElement.style.scrollBehavior = "smooth";
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            };
        }
    }, [containerSize]);

    return (
        <>
            <Header siteSettings={siteSettings}/>
            <form className="row g-3" id="order-form">
                <div className="col-md-6">
                    <div className="container-selection">
                        <h2>{translations.calculate_container_price}</h2>
                        <div>
                            <AddressField setAddress={setAddress} setTrashTypes={setTrashTypes}
                                          setWithValues={setWithValues}
                                          setWithoutValues={setWithoutValues}
                                          setContainerSizes={setContainerSizes}
                                          setTrashType={setTrashType}
                                          setContainerSize={setContainerSize}
                                          setTrashTypesWithSizesMap={setTrashTypesWithSizesMap}
                                          setShowLoader={setShowLoader}
                                          translations={translations}
                                          setContainersNotFound={setContainersNotFound}
                                          addressError={addressError}
                                          selectedAddress={selectedAddress}
                            />
                        </div>
                        <div>
                            <select style={trashTypeError ? {borderColor: 'red'} : {}} name="trashType"
                                    id="trashType" className="form-control"
                                    onChange={handleTrashTypeSelection} placeholder={translations.trash_type}>
                                {trashTypes.map(trashType =>
                                    <option value={trashType.id} key={trashType.id}>{trashType.name}</option>
                                )}
                            </select>
                        </div>
                        <div>
                            <select style={containerSizeError ? {borderColor: 'red'} : {}} name="containerSize"
                                    id="containerSize" className="form-control"
                                    placeholder={translations.container_size}
                                    onChange={handleContainerSizeSelection}>
                                {containerSizes.map(containerSize => {
                                        if (trashTypeSizesMap.includes(containerSize.id)) {
                                            return <option value={containerSize.id}
                                                           key={containerSize.id}>{containerSize.name}</option>
                                        } else {
                                            return null;
                                        }
                                    }
                                )}
                            </select>
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="image-style">
                        <ContainerDescription contentLink={'/container-description'}
                                              containerSize={containerSize}
                                              trashType={trashType}
                                              selectedImage={selectedContainerSizeImage}
                                              translations={translations}
                        />
                    </div>
                </div>

                <span ref={ref} className="invisible"></span>
                <div className="col-md-12">
                    <div id="calendar-wrapper" style={selectedDateError ? {borderColor: 'red'} : {}}>
                        <span id="discount-label" dangerouslySetInnerHTML={{__html: translations.discount_text}}/>
                        {withValues &&
                            <Calendar key={hash} address={address} trashType={trashType} containerSize={containerSize}
                                      translations={translations}
                                      disabled={false} setSelectedDate={setSelectedDate}
                                      setSelectedPrice={setSelectedPrice}
                                      withValues={hash}
                                      setSelectedContainer={setSelectedContainer}
                                      maxYearToSelect={maxYearToSelect}
                                      setShowLoader={setShowLoader}
                                      beforeForm={beforeForm}
                                      setContainerId={setContainerId}
                            />
                        }

                        {withoutValues &&
                            <Calendar address={address} trashType={trashType} containerSize={containerSize}
                                      translations={translations}
                                      disabled={true} setSelectedDate={setSelectedDate}
                                      setSelectedPrice={setSelectedPrice}
                                      setSelectedContainer={setSelectedContainer} withValues={hash}
                                      maxYearToSelect={maxYearToSelect}
                                      setShowLoader={setShowLoader}
                                      beforeForm={beforeForm}
                                      setContainerId={setContainerId}
                            />
                        }
                    </div>
                </div>
                <div className="col-md-12">
                    <DaysCountForFreeParkingLabel containerId={containerId}/>
                    <ContainerDescriptionButton contentLink={'/container-description'}
                                                containerSize={containerSize}
                                                trashType={trashType}
                                                translations={translations}
                    />
                </div>
                <span ref={beforeForm} className="invisible"></span>
                <div className="col-md-12">
                    <h2 className={"info"}>{translations.on_request_message}</h2>
                </div>
                <div className="col-md-12">
                    <FormControl id="user-order-type">
                        <RadioGroup
                            name="orderPersonData"
                            value={orderPersonType}
                            onChange={handleOrderPersonTypeChange}
                        >
                            <FormControlLabel value="individual" control={<Radio/>}
                                              label={translations.order_user_type_individual}/>
                            <FormControlLabel value="company" control={<Radio/>}
                                              label={translations.order_user_type_company}/>
                        </RadioGroup>
                    </FormControl>
                </div>

                {orderPersonType == 'individual'
                    && <PersonFormData translations={translations}
                                       nameSurNameError={nameSurNameError}
                                       nameSurname={nameSurname}
                                       emailError={emailError}
                                       email={email}
                                       phoneNumberError={phoneNumberError}
                                       phoneNumber={phoneNumber}
                                       message={message}
                                       setNameSurname={setNameSurname}
                                       setEmail={setEmail}
                                       setPhoneNumber={setPhoneNumber}
                                       setMessage={setMessage}
                    />
                }
                {orderPersonType == 'company'
                    && <CompanyFormData translations={translations}
                                        companyNameError={nameSurNameError}
                                        companyName={nameSurname}
                                        companyCodeError={personalCodeError}
                                        companyCode={personalCode}
                                        responsiblePersonError={responsiblePersonError}
                                        responsiblePerson={responsiblePerson}
                                        emailError={emailError}
                                        email={email}
                                        phoneNumberError={phoneNumberError}
                                        phoneNumber={phoneNumber}
                                        message={message}
                                        setCompanyName={setNameSurname}
                                        setCompanyCode={setPersonalCode}
                                        setResponsiblePerson={setResponsiblePerson}
                                        setEmail={setEmail}
                                        setPhoneNumber={setPhoneNumber}
                                        setMessage={setMessage}
                    />
                }
                <div className="col-md-12">
                    <input type="checkbox"
                           defaultChecked={termAndConditions}
                           onChange={() => setTermsAndConditions((state) => !state)}/><TermsAndConditions
                    contentLink={'/terms-and-conditions'}
                    buttonText={translations.terms_and_conditions}
                    customStyle={null}
                    valueNotSelected={termsAndConditionsError}/>
                    <span className="grey-color"> {translations.and} </span>
                    <TermsAndConditions
                        contentLink={'/privacy-and-policy'}
                        buttonText={translations.privacy_and_policy}
                        customStyle={'no-margin-left'}
                        valueNotSelected={termsAndConditionsError}/>
                </div>
                <div>
                    <button type="submit" className="w-100 btn btn-primary btn-lg"
                            onClick={submitOrder}>{translations.order_container}</button>
                </div>
            </form>
            <OrderConfirm orderConfirmed={orderConfirmed} onRequestOrder={onRequestOrder} translations={translations}/>
            <Loader showLoader={showLoader}/>
            <RequestForm showForm={containersNotFound} translations={translations} address={address}
                         setOrderConfirmed={setOrderConfirmed} hideSearchForm={true} apiUrl={'/'}
                         setOnRequestOrder={setOnRequestOrder}/>
            <ScrollTopButton/>
        </>
    );
};
